import { useEffect } from 'react';

import { companyByIdQuery } from '@/entities/company/queries';
import { useAppQuery } from '@/shared/lib/useAppQuery';
import { useNotifications } from '@/shared/ui/Notifications';

export function useCompanyById(companyId: string | undefined) {
  const { addNotification } = useNotifications();

  const { data, isError, error, isFetching, ...otherQueryData } = useAppQuery({
    ...companyByIdQuery(companyId!),
    enabled: !!companyId,
    customError: true,
  });

  useEffect(() => {
    if (isError && error) {
      addNotification({
        type: 'error',
        title: error.message,
        caption: error.data?.details,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  return { company: data || undefined, isError, error, ...otherQueryData };
}
